import { __assign } from "tslib";
import React from 'react';
import { Waypoint } from 'react-waypoint';
import Comment from '../../../Comment';
import { updateCommentOffset } from '../../helpers';
var OffsetTrackingComment = function (props) {
    return (React.createElement(Waypoint, { topOffset: "-100px", bottomOffset: "100%", onEnter: function () { return updateCommentOffset(props.comment); } },
        React.createElement("div", null,
            React.createElement(Comment, __assign({}, props)))));
};
OffsetTrackingComment.displayName = 'OffsetTrackingComment';
export default OffsetTrackingComment;
//# sourceMappingURL=OffsetTrackingComment.js.map